<div class="form">
  <div class="label">Please enter the version number</div>
  <input [(ngModel)]="tagVersion[0]">
  <input [(ngModel)]="tagVersion[1]">
  <input [(ngModel)]="tagVersion[2]">

</div>

<mat-error *ngIf="!valid">
  All fields must be set!<br/>
  Only numbers are allowed to tag your version!
</mat-error>
<div class="button-right-container">
  <button (click)="cancel()" class="ibexfusion-raised-button" mat-button>cancel</button>
  <button (click)="save()" class="ibexfusion-raised-button" mat-button>save</button>
</div>

